


$(window).on('scroll', function(){

    if( $(window).scrollTop()>=109 ){
        $('.site-header').addClass('fixed');
    }else{
        $('.site-header').removeClass('fixed');
    }

    //if( $(window).scrollTop()>=188 ){
    if( $(window).scrollTop()>=95 ){
        $('.site-header').addClass('scrolled');
    }else{
        $('.site-header').removeClass('scrolled');
    }

    var $mapElem = $('#trouver-etablissement-map');

    if( $mapElem.length ){

        var $controlsElem = $mapElem.find('.leaflet-control-container > .leaflet-top');
        var $mapFromTop = parseInt($mapElem.offset().top - $(window).scrollTop());

        if($mapFromTop<=110){
            $controlsElem.css('top', (110-$mapFromTop));
        }else{
            $controlsElem.css('top', 0);
        }


    }


});

// $('.site-header').click(function(){
//     var current = $(window).scrollTop();
//     $(window).scrollTop(current+1);
//     console.log(current+1);
// });